'use client';

import type { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { createClient } from '@/lib/supabase';

interface StartTopupCheckoutParams {
  productId: string;
  router: AppRouterInstance;
}

export async function startTopupCheckout({
  productId,
  router,
}: StartTopupCheckoutParams) {
  const supabase = createClient();
  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (!session?.access_token) {
    router.push('/login');
    return;
  }

  const response = await fetch('/api/payments/mercadopago/create-preference', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify({ productId }),
  });

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(data?.error || 'No se pudo iniciar el checkout');
  }

  const checkoutUrl = data?.checkoutUrl || data?.sandboxCheckoutUrl || data?.initPoint;

  if (!checkoutUrl) {
    throw new Error('Mercado Pago no devolvió una URL de checkout');
  }

  window.location.href = checkoutUrl;
}
